import urlParse from 'url-parse';

declare const _OL_ORIGIN: string;

export const OL_ORIGIN = _OL_ORIGIN;
export const MAIN_DOMAIN = urlParse(_OL_ORIGIN).host; // inc port
